import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import authenticationSlice from "./slices/authentication";
import recoveriesSlice from "./slices/recoveries";
import settingsSlice from "./slices/settings";
import newTreesSlice from "./slices/trees";
import UISlice from "./slices/UI";
import warehouseSlice from "./slices/warehouse";
import workersSlice from "./slices/workers";

export const persistSessionID = "cloner-session";

const authPersistConfig = {
  key: "auth",
  storage: localStorage.getItem(persistSessionID) ? storage : storageSession,
  stateReconciler: hardSet,
  blacklist: ['warehouse', 'files', 'repositories']
};

export const sessionPersistConfig = {
  key: "root",
  storage: storageSession,
  stateReconciler: hardSet,
  blacklist: ['warehouse', 'files', 'repositories']
};

const persistedAuthReducer = persistReducer(
  authPersistConfig,
  authenticationSlice
);

const combinedReducers = combineReducers({
  workers: workersSlice,
  recoveries: recoveriesSlice,
  warehouse: warehouseSlice,
  settings: settingsSlice,
  UI: UISlice,
  newTrees: newTreesSlice,
  authentication: persistedAuthReducer,
});

const rootPersistedReducer = persistReducer(
  sessionPersistConfig,
  combinedReducers
);

const store = configureStore({
  reducer: rootPersistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: {
    maxAge: 500,
  },
});

export default store;
export const persistor = persistStore(store);
